import api from '@/api/interview'

const state = {

}

const actions = {
  searchInterviewRecordList (context, params) {
    return api.searchInterviewRecordList(params)
  },
  resendInvitation (context, invitationInfo) {
    return api.resendInvitation(invitationInfo)
  },
  getCoachAIInterviewInfo (context, params) {
    return api.getCoachAIInterviewInfo(params)
  },
  updateCoachAIInterviewAnswer (context, { candidateId, answerInfo }) {
    return api.updateCoachAIInterviewAnswer(candidateId, answerInfo)
  },
  getInterviewInvitationRecordInfo (context, params) {
    return api.getInterviewInvitationRecordInfo(params)
  },
  getRateRecordList (context, params) {
    return api.getRateRecordList(params)
  },
  getInterviewQuestionTemplateInfo (context, params) {
    return api.getInterviewQuestionTemplateInfo(params)
  },
  moveInterviewQuestionTemplate (context, data) {
    return api.moveInterviewQuestionTemplate(data)
  },
  updateInterviewQuestionTemplate (context, { questionId, data }) {
    return api.updateInterviewQuestionTemplate(questionId, data)
  },
  saveInterviewQuestionTemplate (context, data) {
    return api.saveInterviewQuestionTemplate(data)
  },
  getInterviewQuestionCategoryInfo (context, params) {
    return api.getInterviewQuestionCategoryInfo(params)
  },
  updateInterviewQuestionCategory (context, { categoryId, data }) {
    return api.updateInterviewQuestionCategory(categoryId, data)
  },
  saveInterviewQuestionCategory (context, data) {
    return api.saveInterviewQuestionCategory(data)
  },
  getAIInterviewRoomList (context, companyId) {
    return api.getAIInterviewRoomList(companyId)
  },
  getJobInterviewRoomInfo (context, jobId) {
    return api.getJobInterviewRoomInfo(jobId)
  },
  createOrUpdateJobAIInterviewRoom (context, data) {
    return api.createOrUpdateJobAIInterviewRoom(data)
  },
  inviteAIInterview (context, data) {
    return api.inviteAIInterview(data)
  },
  remindAIInterview (context, data) {
    return api.remindAIInterview(data)
  },
  getAIInterviewRecordInfo (context, params) {
    return api.getAIInterviewRecordInfo(params)
  },
  getHrInterviewQuestionnaireResults (context, params) {
    return api.getHrInterviewQuestionnaireResults(params)
  },
  getCompanyAIInterviewConfig (context) {
    return api.getCompanyAIInterviewConfig()
  },
  createOrUpdateAIInterviewConfig (context, data) {
    return api.createOrUpdateAIInterviewConfig(data)
  },
  getHmInterviewScheduleList (context, data) {
    return api.getHmInterviewScheduleList(data)
  },
  sendInterviewInvitation (context, data) {
    return api.sendInterviewInvitation(data)
  },
  editInvitation (context, data) {
    return api.editInvitation(data)
  },
  getInterviewCriteriaList (context, params) {
    return api.getInterviewCriteriaList(params)
  },
  getInterviewRecordInfo (context, { interviewUuid, params }) {
    return api.getInterviewRecordInfo(interviewUuid, params)
  },
  updateInterviewRecordInfo (context, { interviewUuid, data }) {
    return api.updateInterviewRecordInfo(interviewUuid, data)
  },
  updateInterviewRecordOnlineInfo (context, { interviewUuid, data }) {
    return api.updateInterviewRecordOnlineInfo(interviewUuid, data)
  },
  previewInterviewEmailInfo (context, params) {
    return api.previewInterviewEmailInfo(params)
  },
  getInterviewManagementDashboardInfo (context, params) {
    return api.getInterviewManagementDashboardInfo(params)
  },
  resendInvitationRatingLink (context, invitationInfo) {
    return api.resendInvitationRatingLink(invitationInfo)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
